<template>
  <div class="redirect-container">
    <img
      src="/fanaty-logo-purple.png"
      alt="Fanaty"
      class="logo"
    />
    <a
      href="https://play.google.com/store/apps/details?id=com.fanaty"
      class="download-btn"
    >
      Descarga la app
    </a>
  </div>
</template>

<script>
export default {
  name: 'DeepLinkRedirect',

  created() {
    const ua = navigator.userAgent || navigator.vendor || window.opera
    const isIOS = /iPad|iPhone|iPod/.test(ua) && !window.MSStream
    const isAndroid = /android/i.test(ua)

    // Leer el deep link del query param (ej: ?deepLink=/l/r/141778)
    // Limpiar parámetros fbclid que Instagram agrega automáticamente
    let { deepLink } = this.$route.query
    if (deepLink) {
      const [cleanPath] = deepLink.split('?') // Remover query params (fbclid, etc.)
      deepLink = cleanPath
    }
    const deepLinkUrl = deepLink
      ? `https://app.fanaty.com${deepLink}`
      : 'https://app.fanaty.com'

    if (isAndroid) {
      // En Chrome, intent:// funciona correctamente con browser_fallback_url
      const path = deepLinkUrl.replace(/^https?:\/\//, '')
      const playStoreUrl = 'https://play.google.com/store/apps/details?id=com.fanaty'
      const fallback = encodeURIComponent(playStoreUrl)
      const intentUrl = `intent://${path}#Intent;scheme=https;package=com.fanaty;S.browser_fallback_url=${fallback};end`

      // Si la app está instalada: Chrome/WebView la abre.
      // Si no está instalada: browser_fallback_url redirige al Play Store (en Chrome).
      window.location.href = intentUrl
    } else if (isIOS) {
      // En Safari, intentar abrir la app via Universal Link
      window.location.href = deepLinkUrl

      // Si la app no está instalada, después de 2s ir al App Store
      setTimeout(() => {
        window.location.href = 'itms-apps://apps.apple.com/us/app/fanaty/id1461051554'
      }, 2000)
    } else {
      // Desktop: ir a la web
      window.location.href = 'https://www.fanaty.com/'
    }
  },
}
</script>

<style scoped>
* {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
}

.redirect-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
  background: #0a0a14;
  font-family: 'Inter', -apple-system, BlinkMacSystemFont, sans-serif;
  gap: 20px;
}

.logo {
  width: 80px;
  object-fit: contain;
  opacity: 0.9;
}

.download-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 16px 40px;
  background: #8b5cf6;
  color: #ffffff;
  font-size: 16px;
  font-weight: 700;
  border: none;
  border-radius: 12px;
  cursor: pointer;
  letter-spacing: 0.3px;
  text-decoration: none;
  box-shadow: 0 4px 24px rgba(139, 92, 246, 0.4);
  transition: transform 0.15s ease, box-shadow 0.15s ease, background 0.2s ease;
}

.download-btn:hover {
  background: #7c3aed;
  box-shadow: 0 6px 32px rgba(139, 92, 246, 0.5);
}

.download-btn:active {
  transform: scale(0.97);
  box-shadow: 0 2px 16px rgba(139, 92, 246, 0.35);
}
</style>
